import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  LayoutDashboard,
  Package,
  ShoppingCart,
  FileText,
  BarChart3,
  Users,
  Shield,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  PlusCircle,
  Heart,
  MessageSquare,
  FileCheck,
  PieChart,
  X,
  Bell,
  HelpCircle,
  Clock,
  DollarSign,
  BarChart2,
  Home,
  User,
  ShoppingBag,
  LogOut
} from 'lucide-react';

const Sidebar = ({ isOpen, onClose, isCollapsed, onToggleCollapse }) => {
  const { user, logout, isBuyer, isSeller, isAdmin } = useAuth();
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({});
  
  // const getOptionalComponents = (section) => {
  //   const components = {
  //     products: [
  //       {
  //         name: 'Add New Product',
  //         icon: PlusCircle,
  //         to: '/seller/myproducts/add',
  //         description: 'Create new product listing'
  //       }
  //     ]
  //   };
    
  //   return components[section] || [];
  // };

  const buyerNavItems = [
    { 
      name: 'Home', 
      icon: LayoutDashboard, 
      to: '/buyer/dashboard',
      exact: true 
    },
    { 
      name: 'Products', 
      icon: Package, 
      to: '/buyer/products',
      optionalKey: 'products',
      // optionalComponents: getOptionalComponents('products')
    },
    
     { 
    name: 'My Orders',  // Add this
    icon: ShoppingBag, 
    to: '/buyer/orders' 
  },
  //   { 
  //   name: 'Chats', 
  //   icon: MessageSquare, 
  //   to: '/buyer/chats'  
  // },
    // { 
    //   name: 'Favorites', 
    //   icon: Heart, 
    //   to: '/buyer/favorites' 
    // },
    // { 
    //   name: 'Analytics', 
    //   icon: BarChart3, 
    //   to: '/buyer/analytics' 
    // }
  ];

  const sellerNavItems = [
    { 
      name: 'Home', 
      icon: Home, 
      to: '/seller/dashboard',
      exact: true 
    },
    { 
      name: 'My Products', 
      icon: Package, 
      to: '/seller/myproducts' 
    },
  //   { 
  //   name: 'Chats', 
  //   icon: MessageSquare, 
  //   to: '/seller/chats' 
  // },
  ];

  const adminNavItems = [
    // { 
    //   name: 'Home', 
    //   icon: LayoutDashboard, 
    //   to: '/admin/dashboard',
    //   exact: true 
    // },
    { 
      name: 'Users', 
      icon: Users, 
      to: '/admin/users' 
    },
    { 
      name: 'Products', 
      icon: Package, 
      to: '/admin/products' 
    },
  //    { 
  //   name: 'Messages', 
  //   icon: MessageSquare, 
  //   to: '/admin/chats' 
  // },
   { 
    name: 'Oders', 
    icon: ShoppingBag, 
    to: '/admin/orders' 
  },
  ];

  const navItems = isBuyer ? buyerNavItems : isSeller ? sellerNavItems : adminNavItems;

  const toggleExpand = (menuName) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuName]: !prev[menuName]
    }));
  };

  const isActivePath = (to, exact = false) => {
    if (exact) {
      return location.pathname === to;
    }
    return location.pathname.startsWith(to);
  };

  const NavItem = ({ item, level = 0 }) => {
    const hasOptionalComponents = item.optionalComponents && item.optionalComponents.length > 0;
    const isExpanded = expandedMenus[item.name] || false;
    const isActive = isActivePath(item.to, item.exact);
    
    return (
      <div className="mb-1">
        <div className={`relative ${level > 0 ? 'ml-2' : ''}`}>
          <button
            onClick={() => {
              if (hasOptionalComponents) {
                toggleExpand(item.name);
              } else {
                onClose();
              }
            }}
            className={`
              flex items-center justify-between w-full px-4 py-3 text-sm font-medium rounded-lg transition-all duration-200
              ${isActive
                ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-md'
                : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
              }
              ${level > 0 ? 'py-2.5 text-sm' : ''}
              ${isCollapsed ? 'justify-center px-3 py-4' : ''}
            `}
          >
            <div className="flex items-center">
              <item.icon className={`${level > 0 ? 'h-4 w-4' : 'h-5 w-5'} ${isCollapsed ? 'mx-auto' : 'mr-3'} ${isActive ? 'text-white' : 'text-current'}`} />
              {!isCollapsed && (
                <span className="text-left font-medium">
                  {item.name}
                  {level > 0 && item.description && (
                    <span className="block text-xs text-gray-500 mt-0.5">
                      {item.description}
                    </span>
                  )}
                </span>
              )}
            </div>
            {!isCollapsed && hasOptionalComponents && (
              <ChevronDown className={`h-4 w-4 transition-transform ${isExpanded ? 'rotate-180' : ''} ${isActive ? 'text-white' : 'text-gray-500'}`} />
            )}
          </button>
          
          {/* Main link (clickable area for navigation) */}
          {!hasOptionalComponents && (
            <NavLink
              to={item.to}
              className="absolute inset-0"
              onClick={onClose}
              end={item.exact}
            />
          )}
        </div>

        {/* Optional Components Submenu */}
        {!isCollapsed && hasOptionalComponents && isExpanded && (
          <div className={`mt-1 ${level === 0 ? 'ml-4 border-l border-gray-200' : ''}`}>
            {item.optionalComponents.map((subItem) => (
              <div key={subItem.name} className="relative">
                <NavLink
                  to={subItem.to}
                  className={({ isActive }) =>
                    `flex items-center px-4 py-2.5 text-sm transition-all duration-200 rounded-lg mx-2 my-1
                    ${isActive
                      ? 'bg-orange-50 text-orange-600 border-l-2 border-orange-400'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50 hover:border-l-2 hover:border-gray-200'
                    }`
                  }
                  onClick={onClose}
                >
                  <subItem.icon className="h-4 w-4 mr-3" />
                  <div>
                    <span className="font-medium">{subItem.name}</span>
                    {subItem.description && (
                      <p className="text-xs text-gray-500 mt-0.5">
                        {subItem.description}
                      </p>
                    )}
                  </div>
                </NavLink>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  // Get user's initials for avatar
  const getUserInitials = () => {
    if (!user?.name) return 'U';
    return user.name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  // Get user display name
  const getUserDisplayName = () => {
    if (!user?.name) return 'User';
    return user.name.split(' ')[0]; // Just first name
  };

  // Get user role display name
  const getUserRole = () => {
    if (isBuyer) return 'Buyer Account';
    if (isSeller) return 'Seller Account';
    if (isAdmin) return 'Administrator';
    return 'User';
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={onClose}
        />
      )}
      
      {/* Sidebar - Positioned directly below header */}
      <aside className={`
        fixed z-40 bg-white border-r border-gray-200 transform transition-all duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        ${isCollapsed ? 'w-20' : 'w-64'}
        top-20 left-0 h-[calc(100vh-64px)] lg:h-[calc(100vh-64px)]
        shadow-lg
      `}>
        {/* User Info Section - Moved to top */}
        <div className="p-6 border-b border-gray-200 bg-white">
          <div className={`flex items-center ${isCollapsed ? 'flex-col space-y-3' : 'justify-between'}`}>
            {/* User Info */}
            {user && (
              <>
                {/* User Avatar - Always visible */}
                <div className="relative">
                  <div className={`rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-sm ${
                    isCollapsed ? 'h-10 w-10' : 'h-12 w-12'
                  }`}>
                    <span className={`text-white font-bold ${
                      isCollapsed ? 'text-xs' : 'text-sm'
                    }`}>
                      {isCollapsed ? getUserInitials().substring(0, 1) : getUserInitials()}
                    </span>
                  </div>
                  <div className="absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full bg-green-500 border-2 border-white"></div>
                </div>

                {/* User Details - Only show when not collapsed */}
                {!isCollapsed && (
                  <div className="ml-3 flex-1">
                    <p className="text-sm font-bold text-gray-900 truncate">
                      {getUserDisplayName()}
                    </p>
                    <p className="text-xs text-gray-500 truncate">
                      {getUserRole()}
                    </p>
                    <div className="mt-1">
                      <span className="inline-block px-2 py-0.5 text-[10px] font-semibold rounded-full bg-orange-100 text-orange-800">
                        {user?.profilePercentage || 0}% Profile
                      </span>
                    </div>
                  </div>
                )}

                {/* Collapse Button - Now at top, next to user info */}
                <button
                  onClick={onToggleCollapse}
                  className={`
                    flex items-center justify-center w-8 h-8 rounded-lg 
                    ${isCollapsed ? 'bg-orange-50 text-orange-600' : 'bg-gray-100 text-gray-600'}
                    hover:bg-orange-50 hover:text-orange-600 
                    transition-all duration-200 shadow-sm
                    ${!isCollapsed ? 'ml-2' : ''}
                  `}
                  title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                >
                  {isCollapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
                </button>
              </>
            )}
          </div>
        </div>

        {/* Navigation Section - Scrollable without visible scrollbar */}
        <div className="h-[calc(100vh-224px)] flex flex-col overflow-hidden hover:overflow-y-auto">
          <nav className="flex-1 p-4">
            {/* {!isCollapsed && (
              <h3 className="px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4">
                Navigation
              </h3>
            )} */}
            
            <div className="space-y-1">
              {navItems.map((item) => (
                <NavItem key={item.name} item={item} />
              ))}
            </div>
          </nav>
        </div>

        {/* Bottom Section - Only collapse button when collapsed */}
        {isCollapsed && (
          <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200 bg-white">
            {/* Nothing needed here since collapse button is at top */}
          </div>
        )}
      </aside>
      
      {/* Add custom CSS to hide scrollbar but keep functionality */}
      <style jsx>{`
        .overflow-hidden:hover::-webkit-scrollbar {
          width: 4px;
        }
        .overflow-hidden:hover::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        .overflow-hidden:hover::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }
        .overflow-hidden:hover::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
      `}</style>
    </>
  );
};

export default Sidebar;